export { MatomoInjector } from './src/service/matomo-injector.service'
export { MatomoTracker } from './src/service/matomo-tracker.service';
export { MatomoModule } from './src/matomo-module';
